/**
 * Formate le libellé d'un service en ajoutant "Service " si nécessaire.
 * - undefined/null → undefined (pas d'info = pas d'affichage)
 * - "Service Commercial" → "Service Commercial" (pas de doublon)
 * - "Commercial" → "Service Commercial"
 */
export const formatServiceLibelle = (raw?: string | null): string | undefined => {
    if (!raw) return undefined;
    return raw.startsWith('Service ') ? raw : `Service ${raw}`;
};
